/**
 * Bloc faq object
 */
var faq = {
  params : {
    faqQuestion: '',
    faqResponse: '',
    faqIconShow: '',
    faqIconHide: ''
	},

	init : function(options) {
		this.params = $.extend(this.params,options);
    that = this;

    this.params.faqResponse.hide();

    this.params.faqIconShow.on('click',function() {
      var id = $(this).attr("data-conteneur");
      faq._showResponse(id);
    });

    this.params.faqIconHide.on('click',function() {
      var id = $(this).attr("data-conteneur");
      faq._hideResponse(id);
    })
    
    $('#faq-question-bloc-last-child').on('click',function() {
      if($("html")[0].lang == "fr") {
        window.location.href = "/service-consommateur/";
      } else {
        window.location.href = "/customer-service/";
      }
    })

	},

  _showResponse: function(id_conteneur) {
    $("#faq-response-bloc-"+id_conteneur).show();
  },

  _hideResponse: function(id_conteneur) {
    $("#faq-response-bloc-"+id_conteneur).hide();
  }

}
